<template>
  <el-card class="h-full">
    <!-- input输入框部分 -->
    <div class="mb-20px">
      <el-input
        v-model="searchForm.alarmDescribe"
        class="mr-10px w-200px"
        placeholder="报警描述"
        clearable
      ></el-input>
      <el-select
        v-model="searchForm.alarmSourceId"
        size="small"
        class="mr-10px w-200px"
        placeholder="报警来源"
        clearable
        filterable
      >
        <el-option
          v-for="item in allSourceList"
          :key="item.id"
          :value="item.id"
          :label="item.alarmSource"
        ></el-option>
      </el-select>
      <el-date-picker
        class="mr-10px w-300px"
        type="datetimerange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="searchForm.searchTime"
        clearable
      ></el-date-picker>
      <!-- button按钮部分 -->
      <el-button type="primary" @click="searchAlarmList" :disabled="!$hasAccess('check')">搜索</el-button>
      <el-button @click="reset" :disabled="!$hasAccess('check')">重置</el-button>
    </div>
    <!-- 列表 -->
    <div class="h-[calc(100%-105px)]">
      <el-table
        :data="tableData"
        v-loading="alarmListLoading"
        row-key="id"
        border
        height="100%"
        stripe
        ref="tableRef"
      >
        <el-table-column type="selection" width="50" reserve-selection></el-table-column>
        <el-table-column type="index" label="序号" width="70"></el-table-column>
        <el-table-column prop="alarmDescribe" label="报警描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="alarmSourceName" label="报警来源" show-overflow-tooltip></el-table-column>
        <el-table-column label="报警时间" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.alarmTime ? dayjs(row.alarmTime).format('YYYY-MM-DD HH:mm:ss') : row.alarmTime}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt-20px flex justify-end">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getAlarmList"
        :current-page.sync="page.pageNo"
        :page-sizes="pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import { isNil, cloneDeep, filter } from 'lodash'
import {
  ThreeDimensionalAlarmCenterApi,
  AlarmSourceConfigurationTableApi,
} from '@wiz-api/cloud-render-management'

const alarmCenterApi = new ThreeDimensionalAlarmCenterApi()
const alarmSourceConfig = new AlarmSourceConfigurationTableApi()

export default {
  data() {
    return {
      searchForm: {
        alarmSourceId: '',
        alarmDescribe: '',
        searchTime: [],
      },
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      alarmListLoading: false,
      pageSizeAll: [15, 30, 45, 60, 75, 90],
      allSourceList: [],
    }
  },
  async created() {
    await this.getAlarmList()
    this.getAllSource()
  },
  methods: {
    // 获取报警列表
    async getAlarmList() {
      this.alarmListLoading = true
      const [err, res] = await alarmCenterApi.getThreeDimensionalAlarmList({
        alarmSourceId: this.searchForm.alarmSourceId,
        alarmDescribe: this.searchForm.alarmDescribe,
        startTime: this.searchForm.searchTime ? this.searchForm.searchTime[0] : null,
        endTime: this.searchForm.searchTime ? this.searchForm.searchTime[1] : null,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
      })
      if (!err && !isNil(res)) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
      this.alarmListLoading = false
    },
    // 获取报警来源下拉框数据
    async getAllSource() {
      const [errSelect, resSelect] = await alarmSourceConfig.getAlarmSourceConfigurationList({
        maxResultCount: 1000,
        skipCount: 0,
      })
      if (!errSelect && resSelect) {
        this.allSourceList = resSelect.items
      }
    },
    // 搜索
    searchAlarmList() {
      this.page.pageNo = 1
      this.getAlarmList()
    },
    // 重置
    reset() {
      // 重置搜索表单
      this.searchForm = this.$options.data().searchForm
      this.searchAlarmList()
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.getAlarmList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
